import { Navigate, useRoutes } from "react-router-dom";

import CloudScheduleRoutes from "./cloudschedule/routes";

import IndexPage from "./index";
import InstanceRoutes from "./newsrpm-instance/routes";
import MarketplaceRoutes from "./newsrpm-marketplace/routes";
import ParserRoutes from "./newsrpm-parser/routes";
import ReferenceRoutes from "./reference/routes";

export default () =>
  useRoutes([
    { path: "/reference/*", element: <ReferenceRoutes/> },
    { path: "/cloudschedule/*", element: <CloudScheduleRoutes/> },
    { path: "/newsrpm-marketplace/*", element: <MarketplaceRoutes/> },
    { path: "/newsrpm-parser/*", element: <ParserRoutes/> },
    { path: "/newsrpm-instance/*", element: <InstanceRoutes/> },
    { path: "/*", element: <Navigate to="/not-found"/> },
    { path: "/", element: <IndexPage/> },
  ]);
